var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('board-cell-card',{staticClass:"alarm-count-panel",attrs:{"title":"告警次数及原因统计"}},[_c('div',{staticClass:"alarm-count-panel-content"},[_c('alarm-count-list',{staticClass:"alarm-count-list",attrs:{"list":_vm.state.list}}),_c('list-bottom',{attrs:{"value":_vm.pagination},on:{"change":_vm.handlePageChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }